import { mapActions } from "vuex";


export const composeEmailMethods = mapActions('composeemail', ['add','replyEmailMessage']);